<template>
  <div
    class="productCounterAndCartButtonWrapper"
    v-if="shouldCartAndCounterShow"
  >
    <div class="productCounterAndCartButtonWrapper__quantityMsg">
      Quantity:
      <span class="productCounterAndCartButtonWrapper__boldText">{{
        incrementMsg
      }}</span>
    </div>
    <slot />
    <div :class="errorClass">
      <span
        class="productCounterAndCartButtonWrapper__info-icon"
        v-if="this.getHasDefaultHelpText"
      >
        <span class="material-icons">info</span>
      </span>
      <span :class="messageClass">{{ getErrorMsg }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("addToCartCount", [
      "getShowError",
      "getErrorMsg",
      "getHasDefaultHelpText"
    ]),
    ...mapGetters("product", ["getIsAddToCartHidden"]),
    ...mapGetters("user", ["getIsUserLimited"]),
    ...mapGetters("addToCartCount", [
      "getValidCartCount",
      "getUsingDefaultUnit",
      "getMinimumOrderUnitOfMeasure"
    ]),
    errorClass() {
      const isError = this.getShowError ? " showError" : "";
      return this.getHasDefaultHelpText
        ? `productCounterAndCartButtonWrapper__defaultHelpText${isError}`
        : `productCounterAndCartButtonWrapper__errorText${isError}`;
    },

    messageClass() {
      return this.getHasDefaultHelpText
        ? `productCounterAndCartButtonWrapper__message`
        : "";
    },

    incrementMsg() {
      const showUnitsWithBracketedS = this.getUsingDefaultUnit ? "(s)" : "";

      return `${this.getValidCartCount} ${this.getMinimumOrderUnitOfMeasure}${showUnitsWithBracketedS}`;
    },
    shouldCartAndCounterShow() {
      return !this.getIsAddToCartHidden && !this.getIsUserLimited;
    }
  }
};
</script>

<style lang="scss" scoped>
.productCounterAndCartButtonWrapper {
  font-family: $body;
  color: $darkgray;
  font-size: 14px;
  padding-top: 20px;
  @include media-breakpoint-up(md) {
    padding-top: 30px;
  }
  &__quantityMsg {
    padding-bottom: 8px;
  }
  &__boldText {
    font-weight: bold;
  }
  &__errorText {
    margin-top: 15px;
    line-height: 0;
    font-size: 14px;
    color: $red;
    display: none;
    &.showError {
      display: block;
    }
  }
  &__defaultHelpText {
    margin-top: 15px;
    line-height: 0;
    font-size: 14px;
    color: #666766;
    display: none;
    &.showError {
      display: block;
    }
  }
  &__info-icon {
    .material-icons {
      margin-top: 5px;
      line-height: 0;
      vertical-align: -6px;
      font-size: 20px;
      color: $aqua;
    }
  }
  &__message {
    padding-left: 5px;
  }
}
</style>
